import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NewsService } from 'app/pages/news/news.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environments/environment';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';

@Component({
  selector: 'news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  providers: [NewsService]
})
export class NewsComponent implements OnInit {

  modelList: any[] = [];
  articolo: any = {};
  promiseBusy: Promise<any[]>;
  refreshData: boolean = false;
  pagInizio: number = 0;
  pagFine: number = 10;
  pippo: number;
  numeroArticoli: number = 0;
  listaArticoli: any = {};

  id: any;

  shareUrl: any;
  shareImg: any;
  fbButton: any;
  isDetail: boolean = false;

  // CTA provvisoria personalizzabile per tipologie Bollettino/Allerta
  archiveCtaText: string = "Visualizza l'archivio";
  articlePdfIds: string[] = [];
  isPdfDownloading = false;

  imageOptions = [
    { id: 1, title: 'Default', src: 'assets/images/placeholder_news_default.webp' },
    { id: 2, title: 'Bollettino', src: 'assets/images/placeholder_bollettino.webp' },
    { id: 3, title: 'Avviso', src: 'assets/images/placeholder_avviso.webp' }
  ];


  constructor(
    private route: ActivatedRoute,
    public restService: NewsService,
    private _sanitizer: DomSanitizer,
    private router: Router) {

    (window as any).viewArchCloseModal = this.viewArchCloseModal.bind(this)

    this.route.params.subscribe(params => {

      if (params['id']) {
        window.scrollTo(0, 0);
        this.id = params['id'];
        this.viewNews(this.id);

        this.isDetail = true
      } else {
        this.isDetail = false
        this.createArticoliList();
      }

    });

  }

  getImageSrcById(imgId: number): string {
    const found = this.imageOptions.find(opt => opt.id === imgId);
    return found ? found.src : 'assets/images/placeholder_news_default.webp';
  }

  getImageTitleById(imgId: number): string {
    const found = this.imageOptions.find(opt => opt.id === imgId);
    return found ? found.title : 'Default';
  }

  get showArchiveCta(): boolean {
    // imgId: 2 = Bollettino, 3 = Avviso (Allerta)
    return this.isDetail && (this.articolo?.imgId === 2 || this.articolo?.imgId === 3);
  }

  get hasPdfAttachment(): boolean {
    return this.articlePdfIds.length > 0;
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked() {

    if (this.refreshData) {

      this.refreshData = false;

    }

  }

  visualizzaAltriArticoli() {

    this.pagInizio += 10;
    this.pagFine += 10;
    this.createArticoliList();

  }

  createArticoliList() {

    var ref = this;

    this.promiseBusy = this.restService.selectAll(this.pagInizio, this.pagFine);
    this.promiseBusy.then(
      res => {
        ref.listaArticoli = res;
        ref.numeroArticoli = ref.listaArticoli.totArticoli;
        var articoliList = ref.listaArticoli.articoliBindList;

        for (var i = 0; i < articoliList.length; i++) {
          if (articoliList[i].imgId == '' || articoliList[i].imgId == null) {
            articoliList[i].imgId = 1;
          } else {
          }
          articoliList[i].corpo = ref._sanitizer.bypassSecurityTrustHtml(articoliList[i].corpo);
        }
        this.modelList = this.modelList.concat(articoliList);
        this.refreshData = true;
        this.pippo = articoliList.length;

      }
    ).catch(error => {
      ref.listaArticoli = [];
      ref.numeroArticoli = 0
    })

  }

  routeTo(path) {
    this.router.navigate([path]);
  }

  viewNews(idArticolo: any) {
    this.shareUrl = environment.apiEndpoint + '/news/' + idArticolo;
    this.promiseBusy = this.restService.findById(idArticolo);
    this.promiseBusy.then((res) => {
      const article: any = res as any;
      if (article) {
        // Post-processing del corpo per nascondere i vecchi bottoni inline
        if (article.corpo && typeof article.corpo === 'string') {
          const btnRegex = /<button[^>]*onclick="viewArchCloseModal\(([^)]*)\)"[^>]*>.*?<\/button>/gi;
          const replaced = (article.corpo as string).replace(btnRegex, '');

          const genericBtnRegex = /<button[^>]*>\s*Clicca\s+qui\s+per\s+scaricarlo\s*<\/button>/gi;
          article.corpo = replaced.replace(
            genericBtnRegex,
            `<button style="display:none;"></button>`
          );
        }

        this.articlePdfIds = Array.isArray(article.urlPdfList)
          ? article.urlPdfList
            .filter((id: any) => typeof id === 'string' && id.trim().length > 0)
            .map((id: string) => id.trim())
          : [];

        this.articolo = article;
        this.articolo.corpo = this._sanitizer.bypassSecurityTrustHtml(this.articolo.corpo);
        this.articolo.imgUrlById = this.getImageSrcById(this.articolo.imgId);
      } else {
        this.articolo = {
          titolo: 'Articolo non recuperato',
          corpo: 'Si è verificato un errore nel recuperare i dettagli dell\'articolo.'
        };
        this.articlePdfIds = [];
      }
    }).catch((error) => {
      this.articolo = {
        titolo: 'Articolo non recuperato',
        corpo: 'Si è verificato un errore nel recuperare i dettagli dell\'articolo.'
      };
      this.articlePdfIds = [];
      this.router.navigate(['/errore']);
    });
  }

  viewArchCloseModal(tipo: string) {
    this.router.navigate(['/meteo/archivi']);
  }

  onArchiveCtaClick(): void {
    this.router.navigate(['/meteo/archivi']);
  }

  handleDownloadPdf(): void {
    if (this.isPdfDownloading || !this.hasPdfAttachment) {
      return;
    }

    const pdfId = this.articlePdfIds[0];
    if (!pdfId) {
      return;
    }

    this.isPdfDownloading = true;
    this.restService.getPdfById(pdfId)
      .then(res => {
        if (res && res.file) {
          const link = document.createElement('a');
          link.href = `data:application/pdf;base64,${res.file}`;
          link.download = this.buildPdfFileName();
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error('PDF non disponibile per l\'articolo selezionato.');
        }
      })
      .catch(error => {
        console.error('Errore durante il download del PDF:', error);
      })
      .finally(() => {
        this.isPdfDownloading = false;
      });
  }

  private buildPdfFileName(): string {
    const rawTitle = typeof this.articolo?.titolo === 'string' ? this.articolo.titolo : 'documento';
    const sanitizedTitle = rawTitle
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9-_]+/g, '_')
      .replace(/_{2,}/g, '_')
      .replace(/^_|_$/g, '') || 'documento';

    const rawDate = typeof this.articolo?.dataInserimento === 'string'
      ? this.articolo.dataInserimento.replace(/[^\d]/g, '')
      : '';

    const timestamp = rawDate || (this.articolo?.idArticolo?.toString() ?? 'file');
    return `${sanitizedTitle}_${timestamp}.pdf`.toLowerCase();
  }

}
